// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"179":"main","535":"login"}[chunkId] + "." + {"179":"e1d5f007","535":"080e852b"}[chunkId] + ".js";
};